document.querySelectorAll('.btn-modal').forEach((button) => {
  button.addEventListener('click', () => {
    const dialogId = button.getAttribute('data-dialog')
    const dialog = document.getElementById(dialogId)

    // iframe video using data-src
    const iframe = dialog.querySelector('iframe')
    const src = iframe?.dataset?.src

    if (iframe && src) {
      iframe.src = src
    }

    dialog.showModal() // Open the dialog

    // dialog.addEventListener('click', (event) => {
    //   const dialogContent = dialog.querySelector('.dialog-content')
    //   if (!dialogContent.contains(event.target)) {
    //     closeDialog(dialog)
    //   }
    // })
  })
})

function closeDialog(dialog) {
  const video = dialog.querySelector('video')
  const iframe = dialog.querySelector('iframe')

  if (video) {
    video.pause()
    video.currentTime = 0
  }

  if (iframe) {
    iframe.src = iframe.src
  }

  dialog.close() // Close the dialog
}

document.querySelectorAll('.btn-close').forEach((button) => {
  button.addEventListener('click', () => {
    const dialog = button.closest('dialog') // Find the closest dialog
    closeDialog(dialog)
  })
})

// data-non-modal use - close the dialog if the backdrop is clicked
document.querySelectorAll('dialog').forEach((dialog) => {
  if (dialog.hasAttribute('data-non-modal')) {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        closeDialog(dialog) // close the dialog if the backdrop is clicked
      }
    })
  }
})
